// extracted by mini-css-extract-plugin
export default {"link":"styles_link__TBEPe","linkSecondary":"styles_linkSecondary__W7bs3","right":"styles_right__oVcTn"};